var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import 'bootstrap/dist/css/bootstrap.min.css';
import Row from 'react-bootstrap/Row';
import '../../styles/Footer.css';
import { isMobile } from 'react-device-detect';
export default function Footer(props) {
    return (_jsx(Row, __assign({ className: "footer" }, { children: _jsx(LogoBar, { isMobile: isMobile }) })));
}
function LogoBar(props) {
    var logos = [
        {
            id: "loader-logo-sectoriel",
            href: "https://www.sectoriel.com/fr/",
            src: "imgs/logos-filiales/logo-sectoriel.svg",
            alt: "Sectoriel"
        },
        {
            id: "loader-logo-sferaco",
            href: "https://www.sferaco.com/fr/",
            src: "imgs/logos-filiales/logo-sferaco.svg",
            alt: "Sferaco"
        },
        {
            id: "loader-logo-syveco",
            href: "https://www.syveco.com/en/",
            src: "imgs/logos-filiales/logo-syveco.svg",
            alt: "Syveco"
        }
    ];
    return (_jsx("div", __assign({ className: "subsidiaries-bar", style: { display: !props.isMobile ? 'flex' : 'none' } }, { children: logos.map(function (e) {
            return _jsx(SubsidiaryLogo, { linkRef: e.href, id: e.id, srcImg: e.src, altImg: e.alt }, e.id);
        }) })));
}
function SubsidiaryLogo(props) {
    return (_jsx("a", __assign({ className: "subsidiary-logo", href: props.linkRef, target: "_blank", rel: "noreferrer" }, { children: _jsx("img", { id: props.id, src: props.srcImg, alt: props.altImg }) })));
}
